import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./placeType.css";

import car from "../../images/icons/car.png";
import person from "../../images/icons/person-standing.png";
import motorcycle from "../../images/icons/motorcycle.png";
import cafe from "../../images/icons/cafe.png";
import home from "../../images/icons/home.png";

import { Link } from "react-router-dom";

export default function PlaceType() {
  return (
    <div className="middle-box">
      <h2 className="middle-box-header">من اینجا..</h2>
      <div className="place-type-select-box">
        <div className="place-boxes">
          <Link to="in-cafe" className="place-item">
            <span className="place-item-icon">
              <img src={cafe} alt="" className="cafe" />
            </span>
            در کافه هستم
          </Link>
          <Link to="in-house" className="place-item disabled-place">
            <span className="place-item-icon">
              <img src={home} alt="" className="home" />
            </span>
            در خانه هستم
          </Link>
          <Link to="by-car" className="place-item">
            <span className="place-item-icon">
              <img src={car} alt="" className="car" />
            </span>
            با ماشین هستم
          </Link>
          <Link to="in-person" className="place-item">
            <span className="place-item-icon">
              <img src={person} alt="" className="person" />
            </span>
            پیاده هستم
          </Link>
          <Link to="by-motorcycle" className="place-item">
            <span className="place-item-icon">
              <img src={motorcycle} alt="" className="motorcycle" />
            </span>
            با موتور هستم
          </Link>
        </div>
      </div>
      <Link to="/" className="return-text-link">
        <span className="return-text">
          بازگشت
          <FontAwesomeIcon icon={faChevronLeft} className="return-icon" />
        </span>
      </Link>
    </div>
  );
}
